import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Styles from "../styles/Posts.module.css";

const Post = ({ post, index, page, handleDelete, handleUpdate }) => {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [editedDescription, setEditedDescription] = useState(post.description);
  const [editedTitle, setEditedTitle] = useState(post.title);

  const handleSave = async () => {
    if (handleUpdate) {
      await handleUpdate(post.id, { title: editedTitle, description: editedDescription });
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setEditedDescription(post.description);
    setEditedTitle(post.title);
    setIsEditing(false);
  };

  const handleViewDetails = () => {
    navigate(`/post/${post.id}`);
  };

  return (
    <tr>
      <td>{index + 1}</td>
      <td 
        onClick={handleViewDetails}
        style={{ cursor: 'pointer', color: 'var(--primary-color)' }}
        title="Click to view details"
      >
        {post.id.substring(0, 8)}...
      </td>
      <td>
        {isEditing ? (
          <input
            type="text"
            value={editedTitle}
            onChange={(e) => setEditedTitle(e.target.value)}
            className={Styles.edit_input}
          />
        ) : (
          <span onClick={handleViewDetails} style={{ cursor: 'pointer' }} title="Click to view details">
            {post.title}
          </span>
        )}
      </td>
      <td>
        <div className={Styles.description}>
          {isEditing ? (
            <textarea
              value={editedDescription}
              onChange={(e) => setEditedDescription(e.target.value)}
              rows={4}
              className={Styles.edit_textarea}
            />
          ) : (
            <div className={Styles.description_text}>
              {post.description.length >= 100
                ? post.description.substring(0, 100) + "..."
                : post.description}
            </div>
          )}
        </div>
      </td>
      <td>
        {post.report_reasons?.map((reason, index) => (
          <span key={index}>
            {reason}
            <br />{" "}
          </span>
        ))}
      </td>
      <td>{post.profile?.username || 'Unknown'}</td>
      <td>{post.posted_by}</td>
      <td>
        {isEditing ? (
          <div className={Styles.edit_buttons}>
            <button
              className={Styles.save_button}
              onClick={handleSave}
            >
              Save
            </button>
            <button
              className={Styles.cancel_button}
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        ) : (
          <div className={Styles.action_buttons}>
            <button
              className={Styles.view_button}
              onClick={handleViewDetails}
            >
              View
            </button>
            <button
              className={Styles.edit_button}
              onClick={() => setIsEditing(true)}
            >
              Edit
            </button>
            <button
              className={Styles.delete_button}
              onClick={() => handleDelete(post.id)}
            >
              Delete
            </button>
          </div>
        )}
      </td>
    </tr>
  );
};

export default Post;
